/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC } from 'react'
import { Avatar } from '@mui/material'
import * as teamMembersClasses from 'pagesNew/TeamMembers/TeamMembersPlatformList/styles'
import { searchByStoryteller_searchByStoryteller_items as SuccessStoryStoryteller } from '__generatedTypes__/searchByStoryteller'
import * as classes from '../SuccessStoriesFieldArray/styles'

type Props = {
  successStory: SuccessStoryStoryteller
}

export const SuccessStoryRenderItem: FC<Props> = ({ successStory }) => (
  <div css={teamMembersClasses.renderItem}>
    <div css={teamMembersClasses.block}>
      <div css={teamMembersClasses.avatar}>
        <Avatar src={successStory.getCoverImage || ''} css={teamMembersClasses.avatar} alt="Storyteller avatar" />
      </div>
      <Typography variant="body2" css={[teamMembersClasses.longText, classes.longText]}>
        {successStory.fullName}
      </Typography>
    </div>
  </div>
)
